import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const CountsContainer = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 0.5)};
`;

export const SummaryRow = styled(Flex)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${rem(spacing.base * 1)};
`;
